import { restApiClient } from '@/datasources';

export const CHANGE_CART_SLOT_ROUTE = '/online/cart/change-slot';

export async function changeCartSlot(cartItemsIds: string[], scheduleSlotId: string): Promise<void> {
  await restApiClient.put(CHANGE_CART_SLOT_ROUTE, { cartItemsIds, scheduleSlotId });
}
